import Layout from "@/layout";
var homeRouter = {
  path: "/",
  component: Layout,
  redirect: "/home",
  name: "Main",
  hidden: true,
  meta: {
    title: "首页",
    icon: "home",
    isAllow: true
  },
  children: [{
    path: "home",
    component: function component() {
      return import("@/pages/home/home");
    },
    name: "Home",
    hidden: true,
    meta: {
      title: "首页",
      isAllow: true,
      affix: true
    }
  }]
};
export default homeRouter;